import { useStickyNotifications } from '@amzn/xb-hooks';

export const useDynamicNotifications = () => {
  const { messages, setMessages } = useStickyNotifications();

  return messages.map((message) => ({
    ...message,
    dismissible: true,
    onDismiss: () => {
      setMessages(messages.filter((m) => m !== message));
      message.onDismissCallback?.();
      return true;
    },
  }));
};
